import type { IEventVaultResponse } from "./eventVault.interface"
import type { ISelectItem } from "@/types"

export interface ITemplateEditorForm extends ITemplateColourFields {
  headingFont?: ISelectItem
  baseFont?: ISelectItem
}

export interface ITemplateColourFields {
  headerBackground: string
  footerBackground: string
  primaryColour: string
  secondaryColour: string
  linkText: string
  navText: string
  primaryButtonText: string
  secondaryButtonText: string
  primaryCardText: string
  secondaryCardText: string
  borders: string
}

export enum PresetTheme {
  Default = "default",
  Monochrome = "monochrome",
  BurgundyRust = "burgundy-rust",
  MonochromeInverted = "monochrome-inverted",
  SkyBlue = "sky-blue",
  HappyHolidays = "happy-holidays",
  Evermore = "evermore",
  SunflowerFields = "sunflower_fields",
  ChampagneTuxedos = "champagne_tuxedos",
  LipstickSunsets = "lipstick_sunsets",
  PumpkinPatch = "pumpkin_patch",
  SageGardens = "sage_gardens",
  CosmopolitanPink = "cosmopolitan_pink",
  QuinceCelebrations = "quince_celebrations",
  ChineseNewYear = "chinese_new_year",
}

export interface IPresetTheme extends ISelectItem<PresetTheme> {
  colors: ITemplateColourFields
  fonts: {
    headingFont: string
    baseFont: string
  }
}
export interface ITemplateEventVaultResponse extends IEventVaultResponse {
  IsApplied?: boolean
}
